module.exports = __webpack_public_path__ + "static/3-9a3c03d669760278fd48496444c96609.jpeg";